import React from "react";
import { useTranslation } from "react-i18next";

import { DateTimePicker } from "@common/dateTimePicker";
import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function areDatesEqual(a: Date, b: Date): boolean {
  return (
    a.getUTCFullYear() === b.getUTCFullYear() &&
    a.getUTCMonth() === b.getUTCMonth() &&
    a.getUTCDate() === b.getUTCDate()
  );
}

function Form({ date, taskEndDate, editDate }: Props) {
  const { t } = useTranslation();
  const now = new Date();
  const currentDate = new Date(date);
  const todayUTC = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
  ).toISOString();
  const isEndDateToday =
    !!taskEndDate && areDatesEqual(now, new Date(taskEndDate));
  const [isFreeDateChecked, setIsFreeDateChecked] = React.useState(false);

  return (
    <div className={styles.form}>
      <div
        className={styles.section}
        onClick={() => {
          editDate(todayUTC);
          setIsFreeDateChecked(false);
        }}
      >
        <Checkbox
          isChecked={!isFreeDateChecked && areDatesEqual(currentDate, now)}
        />
        <p className={styles.label}>
          {t("milestoneCompletion.today")}{" "}
          {isEndDateToday ? `(${t("milestoneCompletion.endDate")})` : ""}
        </p>
      </div>
      {!!taskEndDate && !isEndDateToday && (
        <div
          className={styles.section}
          onClick={() => {
            editDate(taskEndDate);
            setIsFreeDateChecked(false);
          }}
        >
          <Checkbox
            isChecked={
              !isFreeDateChecked &&
              areDatesEqual(currentDate, new Date(taskEndDate))
            }
          />
          <p className={styles.label}>
            {t("milestoneCompletion.endDate")} (
            {new Date(taskEndDate).toLocaleDateString()})
          </p>
        </div>
      )}
      <div className={styles.section}>
        <div
          className={styles.freeDateCheckBox}
          onClick={() => setIsFreeDateChecked(!isFreeDateChecked)}
        >
          <Checkbox isChecked={isFreeDateChecked} />
          <p className={styles.label}>{t("milestoneCompletion.anotherDate")}</p>
        </div>
        {isFreeDateChecked && (
          <DateTimePicker
            placeholder={t("milestoneCompletion.placeholder")}
            dateTime={date}
            input={editDate}
          />
        )}
      </div>
    </div>
  );
}

export { Form };
